export interface Creator {
  name: string;
  avatar: string;
}

export interface Tool {
  id: number;
  documentId: string;
  name: string;
  createdAt: string;
  updatedAt: string;
  publishedAt: string;
}

export interface Tutorial {
  id: string;
  documentId: string;
  title: string;
  description: string;
  tags: string[];
  tools: Tool[];
  thumbnailUrl?: string;
  creator: Creator;
  updatedAt: Date;
  duration: string;
  url: string;
  order_index: number;
  is_pinned: boolean;
  is_trial?: boolean;
}

export interface DocumentFilter {
  documentIds: string[];
  type: FilterType;
  reason: FilterReason;
}

export enum FilterType {
  Include = "include",
  Exclude = "exclude",
}

export enum FilterReason {
  Completed = "completed",
  Uninterested = "uninterested",
}

export interface TutorialFilters {
  selectedTags: string[];
  excludedTags: string[];
  documentFilters?: DocumentFilter[];
}
